module.exports = __webpack_public_path__ + "img/ne.e5611bff.jpg";